import request from '@/utils/request'

// 查询用户违规记录
export function getViolationList(data) {
  return request({
    url: '/user/admin/violation/getList',
    method: 'POST',
    data,
  })
}

// 查询用户违规详情
export function getViolationDetail(data) {
  return request({
    url: '/user/admin/violation/getDetail',
    method: 'POST',
    data,
  })
}

// 添加用户黑名单
export function addBlackList(uid) {
  return request({
    url: `/user/admin/common/addBlackList/${uid}`,
    method: 'POST',
  })
}

// 查询用户违规规则列表
export function getViolationConfigList(params) {
  return request({
    url: '/user/admin/violation/config/queryList',
    method: 'GET',
    params,
  })
}

// 批量编辑用户违规规则
export function batchUpdateViolationConfig(data) {
  return request({
    url: '/user/admin/violation/config/batchUpdate',
    method: 'POST',
    data,
  })
}
